import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { withPrefix, Link } from 'gatsby';

export default class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      toggle: false,
      locale: props.locale,
      langSwitch: props.langSwitch,
    };
  }

  handleClick = () => {
    this.setState({ toggle: !this.state.toggle });
  }

  handleLocale = () => {
    this.setState({ locale: !this.state.locale });
  }

  handleLangSwitch() {
    console.log(this.props.locale, 'NEW');
  }

  render() {
    let langSwitch = this.state.langSwitch.startsWith('_') ? this.state.langSwitch.substring(1) : this.state.langSwitch;
    let locale = this.state.locale;
    let toggle = this.state.toggle ? 'open' : 'close';

    const menuButton = (
      <button type="button" id="menuToggle" onClick={this.handleClick.bind(this)} className={toggle} />
    );

    return (
      <div className="nav-wrapper">
        <nav className="navbar slide">
          <Link to={ locale === "en" ? "/" : "/de" } onClick={this.handleLocale} className="presono-logo" itemScope itemType="http://schema.org/Brand" href="#">
            <img itemProp="logo" src={withPrefix('/img/logo.svg')} alt="Presono Logo" />
            <span itemProp="name" style={{ display: "none" }}> presono </span>
          </Link>
          <Link to={ locale === "en" ? "/blog/en/2-min-2-mio/" : "/blog/de/2-min-2-mio/" } className="mmlogo">
            <span>{ locale === "en" ? "known from" : "bekannt aus" }</span>
            <img src={withPrefix('/img/2m2m-logo.png')} alt="2m2m Logo" />
          </Link>
          <ul className={toggle}>
            <li><Link to={ locale === "en" ? "/features" : "/de/features" }>Features</Link></li>
            <li>
              <Link to={ locale === "en" ? "/solutions" : "/de/solutions" }> { locale === "en" ? 'Solutions' : 'Lösungen'}</Link>
              <ul className="sub-nav">
                <div className="inner-nav">
                  <li className="nav-headline">{ locale === "en" ? "Unique Presentations" : "Einzigartiges Präsentieren" }</li>
                  <li>
                    <Link to={ locale === "en" ? "/solutions/en/company" : "/solutions/de/company"} >
                      { locale === "en" ? "... in your Company" : "... im Unternehmen" }
                    </Link>
                  </li>
                  <li>
                    <Link to={ locale === "en" ? "/solutions/en/products" : "/solutions/de/products" }>
                      { locale === "en" ? "... your Products" : "... von Produkten" }
                    </Link>
                  </li>
                  <li>
                    <Link to={ locale === "en" ? "/solutions/en/sales" : "/solutions/de/sales" }>
                      { locale === "en" ? "... in Sales" : "... im Vertrieb" }
                    </Link>
                  </li>
                  <li>
                    <Link to={ locale === "en" ? "/solutions/en/fairs" : "/solutions/de/fairs" }>
                      { locale === "en" ? "... at Fairs" : "... auf Messen" }
                    </Link>
                  </li>
                  <li>
                    <Link to={ locale === "en" ? "/solutions/en/seminars" : "/solutions/de/seminars" }>
                      { locale === "en" ? "... at Seminars" : "... in Seminaren & Schulungen" }
                    </Link>
                  </li>
                  <li>
                    <Link to={ locale === "en" ? "/solutions/en/stores" : "/solutions/de/stores" }>
                      { locale === "en" ? "... in Stores" : "... in Stores" }
                    </Link>
                  </li>
                </div>
              </ul>
            </li>
            <li><Link to={ locale === "en" ? "/apps" : "/de/apps" }>Apps</Link></li>
            <li><Link to={ locale === "en" ? "/pricing" : "/de/pricing" }>{ locale === "en" ? 'Pricing' : 'Preise'} </Link></li>
          </ul>
          <ul className="right">
            <li><Link to={ locale === "en" ? "/blog" : "/de/blog" }>Blog</Link></li>
            <li><Link to={ locale === "en" ? "/contact" : "/de/contact" }>{ locale === "en" ? 'Contact' : 'Kontakt'}</Link></li>
            <li><OutboundLink href="https://my.presono.com/login" target="_blank">Login</OutboundLink></li>
            <li><OutboundLink href="https://register.presono.com" target="_blank" className="button is-rounded nav-button">{ locale === "en" ? 'Sign Up' : 'Registrieren'} </OutboundLink></li>
            <li className="language"><Link onClick={this.handleLangSwitch} to={ langSwitch }>EN | DE</Link></li>
          </ul>
          {menuButton}
        </nav>
      </div>
    );
  }
}
